import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IUserLicense, IUserProfile} from 'app/models/user/user-profile';
import { IUser } from '@shared/models/user';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

@Injectable({providedIn: 'root'})

export class UserService {
  private userProfileApi: string = environment.privateApi + 'UserProfile/';
  private userAdministraitonApi: string = environment.privateApi + 'UserAdministration/';
  private http = inject(HttpClient);

  getUserInfo(): Observable<IUserProfile>{
    return this.http.get<IUserProfile>(this.userProfileApi + "GetUserProfile");
  }

  udpateUserInfo(user: IUserProfile): Observable<IUserProfile>{
    return this.http.post<IUserProfile>(this.userProfileApi + "UpdateUserProfile", user);
  }

  getUsers(accountType: string): Observable<IUser[]> {
    return this.http.get<IUser[]>(this.userAdministraitonApi + 'users/' + accountType,  { withCredentials: true });
  }

  getUser(email: string): Observable<IUser> {
    return this.http.get<IUser>(this.userAdministraitonApi + 'user/' + email,  { withCredentials: true });
  }

  removeUser(username: string): Observable<boolean> {
    return this.http.get<boolean>(this.userAdministraitonApi + 'user/remove/' + username,  { withCredentials: true });
  }

  findUser(filter: string) : Observable<IUser> {
    return this.http.get<IUser>(this.userAdministraitonApi + 'user/find/' + filter,  { withCredentials: true });
  }

  getRoles() : Observable<string[]> {
    return this.http.get<string[]>(this.userAdministraitonApi + 'roles' ,  { withCredentials: true });
  }

  addUser(user: IUser) : Observable<any> {
    return this.http.post<any>(this.userAdministraitonApi + 'user/add', user, httpOptions);
  }

  saveUser(user: IUser) : Observable<any> {
    return this.http.post<any>(this.userAdministraitonApi + 'user/save', user, httpOptions);
  }

  updateUser(user: IUserProfile): Observable<IUserProfile> {
    return this.http.post<IUserProfile>(this.userProfileApi + 'CreateUser', user);
  }

  getUserLicenses() : Observable<IUserLicense[]> {
    return this.http.get<IUserLicense[]>(this.userProfileApi + "GetUserLicenses");
  }
}
